import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import type { ApplicationSdk } from '../../../../../core/sdk';
import { Dropdown } from 'primereact/dropdown';
import OrderDialogStore from '../../stores/OrderDialogStore';

const EditOrderDialog = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const store = sdk.currentDialog || null;

    let objectList: any = sdk.objects?.all.filter(store.currentObjectFilter).map((obj: any) => ({
        label: obj.name,
        value: obj,
    }));

    if (store.selectedObject) {
        if (!objectList.find((obj: any) => obj.value.id === store.selectedObject.id)) {
            objectList.push({
                label: store.selectedObject.name,
                value: store.selectedObject,
            });
        }
    }

    return (
        <Dialog
            visible={!!store}
            header={store.header}
            onHide={() => {
                sdk.closeDialog();
                if (!store.isNewOrder) {
                    sdk.openDialog(OrderDialogStore, { order_id: store.order_id });
                }
            }}
            style={{ width: '40rem' }}
        >
            <div className="p-fluid">
                {/* Dropdown für Objekte */}
                <div
                    className="field"
                    style={{ marginBottom: '1rem' }}
                >
                    <label htmlFor="objectDropdown">Objekt auswählen</label>
                    <Dropdown
                        id="objectDropdown"
                        value={store.selectedObject}
                        options={objectList}
                        onChange={e => store.selectObject(e.value)}
                        placeholder="Objekt auswählen"
                        filter
                        onFilter={e => {
                            store.filterObject(e.filter);
                        }}
                        loading={sdk.objects?.loading || false}
                        style={{ width: '100%' }}
                    />
                </div>
                {/* Dropdown für Reiniger */}
                <div
                    className="field"
                    style={{ marginBottom: '1rem' }}
                >
                    <label htmlFor="employeeDropdown">Reinigungskraft auswählen</label>
                    <Dropdown
                        id="employeeDropdown"
                        value={store.selectedEmployees || 0}
                        options={[
                            { label: 'Keine Reinigungskraft', value: 0 }, // Add this option for null
                            ...(sdk.employee?.all
                                .filter(store.currentEmployeeFilter)
                                .map((employee: any) => ({
                                    label: employee.name,
                                    value: employee.id,
                                })) || []),
                        ]}
                        onChange={e => store.selectEmployee(e.value)}
                        placeholder="Reinigungskraft auswählen"
                        filter
                        onFilter={e => {
                            store.filterEmployees(e.filter);
                        }}
                        loading={sdk.employee?.loading || false}
                        style={{ width: '100%' }}
                    />
                </div>
                {/* Button zum Erstellen des Auftrags */}
                <div style={{ textAlign: 'right', marginTop: '2rem' }}>
                    <Button
                        label={store.buttonLabel}
                        icon="pi pi-check"
                        className="p-button-success"
                        disabled={!store.isValid}
                        onClick={() => {
                            store
                                .createOrUpdateOrder()
                                .then(
                                    ({
                                        id,
                                        event,
                                    }: {
                                        id: number | null;
                                        event: string | null;
                                    }) => {
                                        if (event) {
                                            sdk.closeDialog(event);
                                            sdk.openDialog(OrderDialogStore, { order_id: id });
                                        }
                                    }
                                );
                        }}
                    />
                </div>
            </div>
        </Dialog>
    );
});

export default EditOrderDialog;
